import cn from 'classnames'

import { ArrowIcon } from '@shared'

import styles from './SwiperArrows.module.scss'

type Props = {
  className?: string
  onClickNext: () => void
  onClockPrev: () => void
}

export const SwiperArrows = ({
  className,
  onClickNext,
  onClockPrev,
}: Props) => {
  return (
    <div className={cn(styles.container, className)}>
      <div className={styles.arrowContainer} onClick={onClockPrev}>
        <ArrowIcon />
      </div>
      <div
        className={cn(styles.arrowContainer, styles['arrowContainer-right'])}
        onClick={onClickNext}
      >
        <ArrowIcon className={styles.arrowRight} />
      </div>
    </div>
  )
}
